// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8764406b","239":"b3ddf384","453":"bbb94f3f","455":"2048eec1"}[chunkId] + ".chunk.js";
};